// 外注発注書 pdfプレビュー画面
import { PDFDocument } from 'pdf-lib';
import React, { useState, useEffect, useCallback } from 'react';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import LoadingComponent from '../components/LoadingComponent';
import { useHistory, useParams, Redirect } from 'react-router';
import {
  Button,
  useMediaQuery,
  Snackbar,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogProps,
  DialogContent,
  Table,
  TableCell,
  TableHead,
  TableContainer,
  TableRow,
  TableBody,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useRecoilState } from 'recoil';
import { isLoggedIn } from '../GlobalState';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { getOutSourceDetails } from '../apicalls/outsource';
import { withStyles } from '@material-ui/core/styles';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import { outsourcePdf } from '../generatePdf/outsourcePdf';
import { getPdfDataToDownload } from '../apicalls/savePdf';
import { PdfIcon } from '../components/parts/svgIcon/FileIcon';
import { downloadPdf } from '../utils/downloadDocment';
import { log } from '../utils';

import { PDFViewer } from '../components/parts/pdfPreview/PDFViewer';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

export const PreviewOutsource: React.FC = () => {
  const [pdfURL, setPdfURL] = useState('');
  const [constructionName, setConstructionName] = useState<string>('');
  const history: any = useHistory();
  const params: any = useParams();
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [estimateId, setEstimateId] = useState<number>(0);
  const [taxRate, setTaxRate] = useState<number>(0);

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const [consrtuctionData, setConstructionData] = useState<any>([]);
  const [openSelectModal, setopenSelectModal] = useState(false);
  const [constructId, setConstructId] = useState('');

  const getTheDetailsOfOutSources = useCallback(() => {
    getOutSourceDetails(params.id).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            previewPdf(data.data);
            setConstructionName(data.data.construction_name);
          }
        }
      }
    });
  }, [changeLoggedInData, params.id]);

  useEffect(() => {
    getTheDetailsOfOutSources();
  }, [getTheDetailsOfOutSources]);

  const previewPdf = async (data: any) => {
    if (data.document_id) {
      let pdfDocData = await getPdfDataToDownload(data.document_id);
      const pdfDoc = await PDFDocument.load(pdfDocData.data);
      const exportPdf = await pdfDoc.save();
      const blob = await new Blob([exportPdf], {
        type: 'application/pdf'
      });
      setPdfURL(URL.createObjectURL(blob));
      setLoading(false);
    } else {
      let blob = await outsourcePdf(data);
      setPdfURL(URL.createObjectURL(blob));
      setLoading(false);
    }
  };

  const matches2 = useMediaQuery('(min-width:900px)');

  const [fullWidth] = useState(true);
  const [maxWidth] = useState<DialogProps['maxWidth']>('sm');

  const handleOpenSelectModal = () => {
    setopenSelectModal(true);
  };
  const handleCloseSelectModal = () => {
    setopenSelectModal(false);
  };

  const ModalPopUpComponent = () => {
    return (
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={openSelectModal}
        onClose={handleCloseSelectModal}
        aria-labelledby='max-width-dialog-title'
      >
        <DialogTitle id='confirmation-dialog-title'>
          帳票を作成する工事を選択してください
        </DialogTitle>
        <DialogContent>
          <TableContainer>
            <Table aria-label='sticky table'>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ width: '5%', padding: 0, borderBottom: 'none' }}
                    align={'center'}
                  ></TableCell>
                  <TableCell
                    align={'center'}
                    style={{ width: '14%', padding: 0, borderBottom: 'none' }}
                  >
                    工事番号
                  </TableCell>
                  <TableCell
                    style={{ width: '14%', padding: 0, borderBottom: 'none' }}
                    align={'center'}
                  >
                    工事名
                  </TableCell>

                  <TableCell
                    style={{ width: '14%', padding: 0, borderBottom: 'none' }}
                    align={'center'}
                  >
                    案件種別
                  </TableCell>
                  <TableCell
                    style={{ width: '14%', padding: 0, borderBottom: 'none' }}
                    align={'center'}
                  >
                    顧客名
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {consrtuctionData.length > 0 &&
                  consrtuctionData.map((option: any) => {
                    return (
                      <TableRow key={option.id}>
                        <StyledTableCell
                          align='center'
                          style={{
                            width: '5%',
                            padding: 0,
                            borderBottom: 'none'
                          }}
                        >
                          <RadioGroup
                            aria-label='Select Customer Name'
                            name='Select Customer Name'
                            value={constructId as string}
                            onChange={e => setConstructId(e.target.value)}
                          >
                            <FormControlLabel
                              value={option.id as string}
                              checked={
                                Number(constructId) === Number(option.id)
                              }
                              key={option.id}
                              control={<Radio style={{ color: '#758283' }} />}
                              label={''}
                            />
                          </RadioGroup>
                        </StyledTableCell>
                        <StyledTableCell
                          align={'center'}
                          style={{
                            width: '10%',
                            padding: 0,
                            borderBottom: 'none'
                          }}
                        >
                          {option.code}
                        </StyledTableCell>
                        <StyledTableCell
                          align={'center'}
                          style={{
                            width: '14%',
                            padding: 0,
                            borderBottom: 'none'
                          }}
                        >
                          {option.name}
                        </StyledTableCell>
                        <StyledTableCell
                          align={'center'}
                          style={{
                            width: '14%',
                            padding: 0,
                            borderBottom: 'none'
                          }}
                        >
                          {option.type}
                        </StyledTableCell>
                        <StyledTableCell
                          align={'center'}
                          style={{
                            width: '14%',
                            padding: 0,
                            borderBottom: 'none'
                          }}
                        >
                          {option.customer_name ? option.customer_name : ''}
                        </StyledTableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleCloseSelectModal}
            style={{ color: 'black' }}
          >
            キャンセル
          </Button>
          <Button
            disabled={constructId === ''}
            onClick={() => {
              history.push(`/invoices/create`, {
                state: constructId,
                constructId: constructId,
                estimateId: estimateId,
                taxRate: taxRate,
                url: history.location.pathname
              });
            }}
            style={{ color: 'black' }}
          >
            新規作成
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const backEdit = () => {
    history.replace(`/outsource-orders/${params.id}/edit`, {
      state: params.id,
      rowId: history.location.state.rowId,
      params: history.location.state.params,
      previouspath: history.location.state.previouspath,
      tabs: history.location.state.tabs,
      newOutsourceId: history.location.state.newOutsourceId,
      constructId: history.location.state.constructId
    });
  };

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <AppBarComponent />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            overflow: 'hidden',
            backgroundColor: '#F5F5F5',
            minHeight: window.innerHeight - 120
          }}
        >
          <ModalPopUpComponent />

          <div style={{ margin: 15 }}>
            <div className='table-top-container-customer'>
              <Button
                style={{
                  minWidth: 90,
                  marginRight: 15,
                  color: '#758283',
                  backgroundColor: '#F5F5F5',
                  marginBottom: !matches2 ? 10 : 0
                }}
                variant='contained'
                color='secondary'
                onClick={() => backEdit()}
                startIcon={<ArrowBackIcon />}
              >
                戻る
              </Button>
              <div>
                <Button
                  style={{
                    minWidth: 90,
                    marginRight: 15,
                    color: '#758283',
                    backgroundColor: '#F5F5F5',
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  variant='contained'
                  color='secondary'
                  onClick={() => {
                    log.info(`download: 外注発注書 from preview`);
                    downloadPdf(pdfURL, '外注発注書', constructionName);
                  }}
                >
                  <PdfIcon width={21} height={26} />
                  <div style={{ marginLeft: 8 }}>ダウンロード</div>
                </Button>
              </div>
            </div>

            <PDFViewer src={pdfURL} />
          </div>
        </div>
      )}
      <FooterComponent />
    </>
  );
};
